import React, { useEffect } from 'react';
import FooterSimple from '../common/footer/FooterSimple';
import HeaderNeg from '../common/header/HeaderNeg';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColecctionCardanoTimeline2024 from '../component/timelines/ColecctionCardanoTimeline2024';
import SectionCardanoTimeline2024 from '../component/timelines/SectionCardanoTimeline2024';
import BannerCardanoTimeline2024 from '../component/banner/BannerCardanoTimeline2024';
import BannerYouTubeCT2024 from '../component/banner/BannerYouTubeCT2024';
import ReactGA from 'react-ga';

const CardanoTimeline2024 = () => {

    useEffect(() => {
        ReactGA.pageview('/cardano-timeline');
    }, []);

    return (
        <>
        <SEO title="Cardano Timeline 2024" />
        <ColorSwitcher />
        <main className="main-wrapper">
            <HeaderNeg />
            <BannerCardanoTimeline2024 />
            <div className="youtube-content bg-color-light">   
                <BannerYouTubeCT2024 /> 
            </div>  
            <ColecctionCardanoTimeline2024 />
            <SectionCardanoTimeline2024 />             

            <div className="section section-padding" id="section1">
                <div className="container">
                </div>
            </div>
                 
            <CtaLayoutOne />
            <FooterSimple />
        </main>
        </>
    )
}

export default CardanoTimeline2024;